module.exports = __webpack_public_path__ + "img/ETUDE.0da9287b.svg";